"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var React = __importStar(require("react"));

var PropTypes = __importStar(require("prop-types"));

var SafeAsyncComponent_1 = __importDefault(require("./SafeAsyncComponent"));

var withTheme_1 = require("../utils/withTheme");

var Img =
/** @class */
function (_super) {
  __extends(Img, _super);

  function Img(props) {
    var _this = _super.call(this, props) || this;

    _this.image = null;
    _this.state = {
      loaded: false,
      src: props.src
    };
    _this._onLoad = _this.bindCallback(_this._onLoad);
    return _this;
  }

  Img.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    return this.props.src !== nextProps.src || this.props.className !== nextProps.className || this.state.src !== nextState.src || this.state.loaded !== nextState.loaded;
  };

  Img.prototype.componentDidMount = function () {
    if (this.image && this.image.complete) {
      this.setState({
        loaded: true
      });
    }
  };

  Img.getDerivedStateFromProps = function (nextProps, prevState) {
    if (prevState.src === nextProps.src) {
      return null;
    }

    return {
      src: nextProps.src,
      loaded: false
    };
  };

  Img.prototype.render = function () {
    var _this = this;

    var src = this.state.src;

    if (!src) {
      return null;
    }

    return withTheme_1.withTheme(this.context.theme, {
      image: true,
      'image--is-loaded': this.state.loaded
    })(React.createElement("img", {
      className: this.props.className,
      src: src,
      onLoad: this._onLoad,
      ref: function ref(_ref) {
        return _this.image = _ref;
      },
      alt: ""
    }));
  };

  Img.prototype._onLoad = function () {
    this.setState({
      loaded: true
    });
  };

  Img.contextTypes = __assign({}, SafeAsyncComponent_1["default"].contextTypes, {
    theme: PropTypes.object
  });
  return Img;
}(SafeAsyncComponent_1["default"]);

exports["default"] = Img;